import React, { useEffect, createElement } from 'react';
import { LulutoxLanding } from './pages/LulutoxLanding';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  useEffect(() => {
    // Tracking script
    const trackingScript = document.createElement('script');
    trackingScript.type = 'text/javascript';
    trackingScript.src = 'https://trk.healthproductsguru.com/track.js?rtkcmpid=696598e59cffb3d645728df0';
    document.head.appendChild(trackingScript);
    return () => {
      document.head.removeChild(trackingScript);
    };
  }, []);
  return <>
      <FacebookPixel data-id="element-0" />
      <LulutoxLanding data-id="element-1" />
    </>;
}